export enum ResourceLicenseTypeEnum {
    None = "none",
    Standard = "standard",
    Light = "light",
    Workspace = "pooled"
}